module.exports = __webpack_public_path__ + "static/media/coca-cola-zero.299a6951.jpg";